export const tmpServiceDetail = {
  FETCH_TMP_SERVICE_DETAIL_LOADING: 'FETCH_TMP_SERVICE_DETAIL_LOADING',
  FETCH_TMP_SERVICE_DETAIL_SUCCESS: 'FETCH_TMP_SERVICE_DETAIL_SUCCESS',
  FETCH_TMP_SERVICE_DETAIL_FAILURE: 'FETCH_TMP_SERVICE_DETAIL_FAILURE',
};
